import React from "react";

const Menusca = () => {
  return (
    <section>
    
      <iframe src="https://app.powerbi.com/view?r=eyJrIjoiNGQxOGU3MzItNjExYi00MjIwLWI0NTEtNmY2ZTgzOTdlMTI2IiwidCI6ImYyMzQ4MWYzLTI2ZGItNGZjOC1hNzliLTFiZTk2ZWZjMzg4YyIsImMiOjR9" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default Menusca;
